import { RouteRecordRaw } from 'vue-router'
import companyChildRoutes from '@/router/company'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'manage.companies.list',
    component: () => import('@/views/control-panel/manage/companies/List.vue'),
  },
  {
    path: 'new',
    name: 'manage.companies.create',
    component: () => import('@/views/control-panel/manage/companies/Create.vue'),
  },
  {
    path: ':company',
    name: 'manage.company',
    component: () => import('@/views/control-panel/manage/companies/Company.vue'),
    redirect: (to) => ({ name: 'manage.company.users.list', params: to.params }),
    children: companyChildRoutes
  }
]

export default routes
